import { render, staticRenderFns } from "./StakeForm.vue?vue&type=template&id=12bae18d&"
import script from "./StakeForm.vue?vue&type=script&lang=js&"
export * from "./StakeForm.vue?vue&type=script&lang=js&"
import style0 from "./StakeForm.vue?vue&type=style&index=0&id=12bae18d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports